import React from 'react';
import { Link } from 'react-router-dom';
import './SafetyNotice.css';

// Safety precautions shown wherever people plan or follow a recipe: one quiet line with the
// essentials, which opens to the full precautions and the not-advice note.
const NOTICES = {
  lye: {
    title: 'Safety notes: working with lye',
    summary: 'Goggles and gloves on, add lye to water, and cure 4–6 weeks before use.',
    points: [
      'Wear splash goggles, chemical-resistant gloves and long sleeves. Keep children and pets out of the room.',
      'Add lye to water, never water to lye. Mix with good ventilation, in stainless steel or heat-resistant plastic, never aluminium.',
      'Weigh every ingredient on a digital scale and check the numbers against your recipe before you start. Never change oils without recalculating.',
      'Fresh soap batter is caustic. Cure cold process soap for 4–6 weeks before using or selling it, and make a small test batch of any new recipe.',
      'If lye touches skin or eyes, rinse with plenty of running water for at least 15 minutes and get medical help.',
    ],
  },
  meltPour: {
    title: 'Safety notes: melt & pour',
    summary: 'Melt gently, keep rubbing alcohol away from heat, and test new recipes first.',
    points: [
      'Melted base can burn. Melt gently in short bursts and do not let it boil. Keep children away while you pour.',
      'Rubbing alcohol is flammable. Keep the spray bottle away from heat and flames.',
      'Use fragrances and colourants made for soap, within the supplier’s maximum usage rate.',
      'Keep your base supplier’s ingredient list for your labels, and test new recipes before selling them.',
    ],
  },
  community: {
    title: 'About community recipes',
    summary: 'Shared by members and not checked by SoapLab. Check any recipe in the lye calculator first.',
    points: [
      'These recipes are posted by other users and have not been checked by SoapLab.',
      'Open any recipe in the lye calculator to check its lye and water for your batch size before making it.',
      'Follow lye safety precautions and make a small test batch first.',
    ],
  },
};

export default function SafetyNotice({ variant = 'lye' }) {
  const notice = NOTICES[variant] || NOTICES.lye;
  return (
    <details className="sl-safety-notice">
      <summary>
        <strong className="sl-safety-title">{notice.title}</strong>
        <span className="sl-safety-summary">{notice.summary}</span>
        <span className="sl-safety-more">Read more</span>
      </summary>
      <ul>{notice.points.map((point) => <li key={point}>{point}</li>)}</ul>
      <p className="sl-safety-terms">
        SoapLab’s calculators, recipes and guides are general information, not professional, medical or legal advice. You are responsible for checking your recipes, working safely and following the rules where you make and sell soap. See our <Link to="/terms">Terms of Use</Link>.
      </p>
    </details>
  );
}
